/**
 * Application wide configuration.
 */
const config = {
  enableMock: process.env.REACT_APP_ENABLE_MOCK === 'true',
  firebaseConfig: {
    apiKey: process.env.REACT_APP_GOOGLE_AUTH_API_KEY,
    authDomain: process.env.REACT_APP_GOOGLE_AUTH_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_GOOGLE_AUTH_PROJECT_ID,
    storageBucket: process.env.REACT_APP_GOOGLE_AUTH_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_GOOGLE_AUTH_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_GOOGLE_AUTH_APP_ID,
  },
  apiUrl: process.env.REACT_APP_API_URL,
  endpoints: {
    auth: {
      login: '/auth/login',
      logout: '/auth/logout',
      refresh: '/auth/refresh',
      verify: '/auth',
      current: '/auth/get',
      changePassword: '/auth/change-password',
      forgotPassword: 'auth/forgot-password',
      users: '/users',
      metamask: 'auth/meta-mask',
      authMetaMask: 'auth/meta-mask/authentication',
      googleToken: 'auth/google-token/authentication',
    },
    user: {
      performanceSummary: '/users/performance-summary',
      quarterlyPerformance: '/users/quarterly-performance',
    },

    clients: {
      get: '/client',
    },

    defi: {
      balances: '/defi/v2/balances',
      transactions: '/defi/transactions',
      dashboardTransactions: '/defi/transactions/v2',
      transaction: 'defi/transaction',
      overview: '/defi/dashboard',
      chains: 'defi/chains',
      subpagesOverview: 'defi/dashboard/performance_summary',
      quarterlyPerformance: 'defi/quarterlyPerformance',
      assets: '/defi/v2/assets',
      chainInfo: 'defi/chainInfo',
      performanceSummary: 'defi/performanceSummary',
      performanceSummaryByAccount: 'defi/performanceSummaryByAccount',
    },

    employee: '/employees',

    protocols: {
      get: '/protocols/v2',
    },

    snapshots: {
      get: '/snapshots',
    },

    accounts: {
      v2: {
        get: '/defi/v2/accounts',
      },
      defi: '/defi/accounts',
      create: 'accounts',
      checkIfUnique: 'accounts/is_account_name_unique',
      checkUniqueAddress: 'accounts/is_wallet_address_unique',
      checkUniqueAPIKey: 'accounts/is_api_key_unique',
      checkUniqueSecret: 'accounts/is_api_secret_unique',
      checkUniqueCefiProvider: 'accounts/is_cefi_provider_unique',
      update: 'accounts',
      delete: 'accounts',
      enable: 'accounts',
    },

    users: {
      self: '/users/self',
      get: 'users',
      update: 'users/status',
      checkIfUniqueEmail: 'users/is_email_unique',
    },

    hedgeFunds: {
      get: 'users/hedgefund',
      getHedgeFundManagers: 'users/hedgefund',
      getStandardUsers: 'users/hedgefund',
    },

    standardUser: {
      get: 'users/users',
    },

    plan: {
      get: 'plans',
    },

    subStandardUser: {
      getSubUsers: '/users/standard-users/users',
    },

    subStandardUserTeam: {
      getSubUsersTeam: '/teams',
    },

    notes: {
      get: 'notes',
      create: 'notes',
    },

    superadmin: {
      get: '/users/superadmin',
    },

    contract: {
      get: 'contracts',
      getAll: 'contracts/getAllWithNoLimit',
      checkIfUniqueName: 'contracts/isNameAvailable',
      checkIfUniqueAddress: 'contracts/isAddressAvailable',
    },

    contact: {
      getChainDropdown: 'https://openapi.debank.com/v1/chain/list',
      get: 'contacts',
      getAll: 'contacts/getAllWithNoLimit',
      checkIfUniqueName: 'contacts/isNameAvailable',
      checkIfUniqueAddress: 'contacts/isAddressAvailable',
    },

    network: {
      get: 'users/chains',
      update: 'users/chains',
    },

    profile: {
      get: 'auth/get',
    },

    sync: {
      getSyncStatus: '/users/sync_status',
    },

    exchange: {
      get: 'exchanges',
      transactions: '/exchange/transactions',
      transaction: 'exchange/transaction',
      spotBalances: 'exchange/spot-balances',
      futureBalances: 'exchange/future-balances',
      accounts: 'exchange/accounts',
      overview: '/exchange/dashboard',
      chains: 'exchange/chains',
      subpagesOverview: 'exchange/dashboard/performance_summary',
      quarterlyPerformance: 'exchange/quarterlyPerformance',
      assetInfo: 'exchange/assetInfo',
      accountAssetInfo: 'exchange/accountAssetInfo',
      performanceSummary: 'exchange/performanceSummary',
      performanceSummaryByAccount: 'exchange/accountPerformanceSummary',
      transactionHistory: 'exchange/accountTransactions',
    },

    address: {
      metamask: 'users/isMetaMaskAddressUnique',
    },
  },
};

export default config;
